var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"form-group schema-form-radios {{form.htmlClass}}\" ng-class=\"{'has-error': hasError(), 'has-success': hasSuccess()}\">\n<label class=\"control-label\" ng-show=\"showTitle()\">{{form.title}}</label>\n<div class=\"radio\" ng-repeat=\"item in form.titleMap\">\n<label>\n<input type=\"radio\" class=\"{{form.fieldHtmlClass}}\" sf-changed=\"form\" ng-disabled=\"form.readonly\" ng-model=\"$$value$$\" ng-model-options=\"form.ngModelOptions\" ng-value=\"item.value\" name=\"{{form.key.join('.')}}\">\n<span ng-bind-html=\"item.name\"></span>\n</label>\n</div>\n<div class=\"help-block\" ng-show=\"(hasError() && errorMessage(schemaError())) || form.description\" ng-bind-html=\"(hasError() && errorMessage(schemaError())) || form.description\"></div>\n</div>\n";
var id1="core/-config/schema-form/radios.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/core/-config/schema-form/radios.html
// module id = 931
// module chunks = 0